import { useTranslation } from 'react-i18next';
import { tr } from 'src/modules/i18n-helpers';

/**
 * Returns a typed label lookup function for a Record<Enum, i18nKey> map.
 * Subscribes to language changes so labels re-render on locale switch.
 *
 * @example
 * const getLabel = useGetLabel(TRANSPORTATION_SELECTION_TYPE_LABELS);
 * getLabel(TransportationSelectionType.Pickup) // → translated string
 */
const useGetLabel = <T extends string>(labels: Record<T, string>) => {
  useTranslation(); // subscribe to language changes
  return (value: T) => tr(labels[value]);
};

export default useGetLabel;
